import Group from 'components/utils/Group'
import React from 'react'
import AccommodationRoomDetailsList from './AccommodationRoomDetailsList'
import AccommodationAmenitiesAndPoliciesContent from 'components/AccommodationKit/AccommodationAmenitiesAndPoliciesContent'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import ImageGallery from 'LuxKit/Carousel/ImageGallery'
import { ImageParams } from 'components/Common/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'

const imageProps: ImageParams = {
  mobileAspectRatio: '16:8',
  tabletAspectRatio: '16:8',
  quality: 'good',
}

interface Props {
  roomPackage: App.HotelPackage
}

function AccommodationRoomDetailsModal(props: Props) {
  const { roomPackage } = props

  return <ModalBase>
    <ModalHeader title={roomPackage.roomType.name} />
    <ModalBody>
      {!!roomPackage.roomType.images.length && <ModalContent flush>
        <ImageGallery
          images={roomPackage.roomType.images}
          imageParams={imageProps}
        />
      </ModalContent>}
      <ModalContent>
        <Group direction="vertical" gap={20}>
          <VerticalSpacer gap={16}>
            <BodyTextBlock variant="large">{roomPackage.roomType.description}</BodyTextBlock>
            <AccommodationRoomDetailsList roomPackage={roomPackage} />
          </VerticalSpacer>
          <div>
            <AccommodationAmenitiesAndPoliciesContent roomPackage={roomPackage} />
          </div>
        </Group>
      </ModalContent>
    </ModalBody>
  </ModalBase>
}

export default AccommodationRoomDetailsModal
